
export const SafeParseJSON = (toParse) => {
  let parsed = "";
  try {
    parsed = JSON.parse(toParse);
  }catch (error) {
    parsed = null;
    console.error(error);
  }finally{
    return parsed;
  }
}